import Axios from '@/utils/axios'

export default {
  getPerguntasAndRespostas: (idEmpresaFuncionario, mapeamentoPsicossocial) => {
    return Axios.get(`/avaliacao-psicossocial/${idEmpresaFuncionario}`, { params: { mapeamentoPsicossocial } })
  },
  finalizarAvaliacaoPsicossocial: ({ idEmpresaFuncionario, respostas, mapeamentoPsicossocial }) => {
    return Axios.post('/avaliacao-psicossocial/finalizar', {
      idEmpresaFuncionario,
      respostas,
      mapeamentoPsicossocial
    })
  },
  getMapeamentosEmpresa: () => {
    return Axios.get('/avaliacao-psicossocial/mapeamentos-empresa')
  },
  getRespostasDoFuncionario: idMapeamento => {
    return Axios.get(`/avaliacao-psicossocial/respostas/${idMapeamento}`)
  }
}
